/* Ombrail — "See it in your room" (v18).
   State is kept while the page is open: closing the dialog does not cancel a view in progress or
   clear the photo, note or result. The page behind the dialog does not scroll while it is open. */
(() => {
  const room = document.querySelector('[data-o-room-dialog]');
  if (!room) return;
  const q = (sel) => room.querySelector(sel);
  const qa = (sel) => Array.from(room.querySelectorAll(sel));
  const shell = q('.o-rv__shell');
  const endpoint = (room.dataset.endpoint || '').replace(/\/$/, '');
  const fileInput = q('[data-o-room-file]');
  const photo = q('[data-o-room-photo]');
  const change = q('[data-o-room-caption]');
  const empty = q('[data-o-room-empty]');
  const fileStatus = q('[data-o-room-file-name]');
  const note = q('[data-o-room-note]');
  const error = q('[data-o-room-error]');
  const status = q('[data-o-room-status]');
  const generate = q('[data-o-room-generate]');
  const generateNote = q('[data-o-room-generate-note]');
  const consentWrap = q('[data-o-room-consent-wrap]');
  const consent = q('[data-o-room-consent]');
  const notifyCard = q('[data-o-room-notify-card]');
  const loading = q('[data-o-room-loading]');
  const loadingStep = q('[data-o-room-loading-step]');
  const result = q('[data-o-room-result]');
  const resultImg = q('[data-o-room-result-img]');
  const beforeImg = q('[data-o-room-before-img]');
  const setup = q('[data-o-room-setup]');
  const done = q('[data-o-room-after]');
  const download = q('[data-o-room-download]');
  const again = q('[data-o-room-again]');
  const next = q('[data-o-room-next]');
  const drop = q('[data-o-room-drop]');
  const toast = document.querySelector('[data-o-room-toast]');

  let photoUrl;
  let opener;
  let ready = null;
  let check;
  let busy = false;
  let stepTimer;

  const setState = (state) => { shell.dataset.state = state; };
  const lock = (on) => document.documentElement.classList.toggle('o-rv-lock', on);

  const open = (from) => {
    opener = from || opener;
    window.OmbrailAI?.close();
    if (toast) toast.hidden = true;
    if (!room.open) room.showModal();
    lock(true);
    checkService();
  };
  const close = () => { if (room.open) room.close(); };

  document.querySelectorAll('[data-o-room-open]').forEach((b) => b.addEventListener('click', () => open(b)));
  q('[data-o-room-close]').addEventListener('click', close);
  room.addEventListener('click', (e) => { if (e.target === room) close(); });
  room.addEventListener('close', () => {
    lock(false);
    opener?.focus({ preventScroll: true });
  });

  // Fallback "notify me" when the service is off.
  const notify = q('[data-o-room-notify]');
  notify?.addEventListener('click', (e) => {
    if (typeof window.OmbrailOpenQuote !== 'function') return;
    e.preventDefault();
    close();
    window.OmbrailOpenQuote('room', '', notify);
  });

  // Scale drawing on the product page (kept open while a view is being created).
  const drawingLink = document.querySelector('[data-o-show-drawing]');
  const hasDrawing = drawingLink && document.querySelector('[data-o-drawing]');
  [q('[data-o-room-scale]'), q('[data-o-room-scale-after]')].forEach((link) => {
    if (!link || !hasDrawing) return;
    link.hidden = false;
    link.addEventListener('click', () => { close(); drawingLink.click(); });
  });

  // Photo
  fileInput.addEventListener('change', () => {
    const file = fileInput.files?.[0];
    if (!file) return;
    error.hidden = true;
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
      showError('Choose a JPG, PNG or WebP image smaller than 10 MB.');
      fileInput.value = '';
      return;
    }
    if (busy) return;
    if (photoUrl) URL.revokeObjectURL(photoUrl);
    photoUrl = URL.createObjectURL(file);
    photo.src = photoUrl;
    photo.hidden = false;
    empty.hidden = true;
    change.hidden = false;
    fileStatus.textContent = '✓ ' + file.name;
    fileStatus.classList.add('is-ok');
    showSetup();
    updateGenerate();
  });

  // Optional placement note
  qa('[data-o-room-chip]').forEach((chip) => chip.addEventListener('click', () => {
    note.value = chip.textContent.trim();
    note.focus();
  }));

  // Service availability
  const checkService = () => {
    if (!endpoint) { ready = false; return Promise.resolve(); }
    if (check) return check;
    check = fetch(endpoint + '/health', { mode: 'cors' })
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => { ready = Boolean(d && d.room); })
      .catch(() => { ready = false; })
      .finally(applyMode);
    return check;
  };
  function applyMode() {
    if (!ready) {
      shell.classList.add('is-off');
      return;
    }
    shell.classList.remove('is-off');
    if (status) status.textContent = 'AI view';
    consentWrap.hidden = false;
    if (notifyCard) notifyCard.hidden = true;
    const primary = document.querySelector('[data-o-primary-action]');
    if (primary) {
      next.hidden = false;
      next.textContent = primary.tagName === 'BUTTON' ? 'Add to cart' : 'Request a quote';
    }
    updateGenerate();
  }
  function updateGenerate() {
    if (!ready) return;
    generate.disabled = busy || !photoUrl || !consent.checked;
    generateNote.textContent = busy ? 'Creating…' : !photoUrl ? 'Add a photo first' : !consent.checked ? 'Tick the box above' : 'About 30 to 60 seconds';
    generate.classList.toggle('is-ready', !generate.disabled);
  }
  consent.addEventListener('change', updateGenerate);

  const notifyClosed = (text) => {
    if (room.open || !toast) return;
    toast.querySelector('span').textContent = text;
    toast.hidden = false;
  };
  const showError = (message) => { error.textContent = message; error.hidden = false; };
  const showSetup = () => {
    result.hidden = true;
    done.hidden = true;
    setup.hidden = false;
    drop.hidden = false;
    setState(photoUrl ? 'photo' : 'empty');
  };
  const showResult = () => {
    drop.hidden = true;
    result.hidden = false;
    setup.hidden = true;
    done.hidden = false;
    setState('result');
  };

  const prepareImage = () => new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const max = 1536;
      const scale = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
      const w = Math.round(img.naturalWidth * scale);
      const h = Math.round(img.naturalHeight * scale);
      const c = document.createElement('canvas');
      c.width = w; c.height = h;
      c.getContext('2d').drawImage(img, 0, 0, w, h);
      resolve({ dataUrl: c.toDataURL('image/jpeg', 0.86), width: w, height: h });
    };
    img.onerror = reject;
    img.src = photoUrl;
  });

  const STEPS = ['Reading your room…', 'Measuring the space…', 'Placing the piece at its real size…', 'Matching the light and shadows…', 'Finishing the details…'];
  const MESSAGES = {
    rate_limited: 'You have created several views in a short time. Please try again a little later.',
    busy: 'Our room view is very busy right now. Please try again in a minute.',
    moderation_blocked: 'This photo could not be used. Please try another photo of your room.',
    bad_image: 'This photo could not be read. Please choose a JPG, PNG or WebP image.',
    product_not_found: 'This piece cannot be shown in a room yet. Please ask our team.',
    product_image_unavailable: 'This piece cannot be shown in a room yet. Please ask our team.',
  };

  const run = async () => {
    if (generate.disabled || busy) return;
    busy = true;
    error.hidden = true;
    loading.hidden = false;
    setState('loading');
    let i = 0;
    loadingStep.textContent = STEPS[0];
    clearInterval(stepTimer);
    stepTimer = setInterval(() => { i = Math.min(i + 1, STEPS.length - 1); loadingStep.textContent = STEPS[i]; }, 9000);
    updateGenerate();
    q('.o-rv__body').scrollTo({ top: 0, behavior: 'smooth' });
    try {
      const prepared = await prepareImage();
      const res = await fetch(endpoint + '/room', {
        method: 'POST',
        mode: 'cors',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          image: prepared.dataUrl, width: prepared.width, height: prepared.height, consent: true,
          note: (note.value || '').trim().slice(0, 200),
          handle: room.dataset.handle || '', dimensions: room.dataset.dims || '', material: room.dataset.material || '',
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.image) {
        showSetup();
        showError(MESSAGES[data.error] || 'The room view is unavailable right now. Please try again later.');
        notifyClosed('We could not create your room view.');
        return;
      }
      resultImg.src = data.image;
      beforeImg.src = photoUrl;
      setView('after');
      download.href = data.image;
      showResult();
      q('.o-rv__body').scrollTo({ top: 0 });
      notifyClosed('Your room view is ready.');
    } catch (e) {
      showSetup();
      showError('The room view is unavailable right now. Please try again later.');
      notifyClosed('We could not create your room view.');
    } finally {
      busy = false;
      clearInterval(stepTimer);
      loading.hidden = true;
      if (shell.dataset.state === 'loading') setState(photoUrl ? 'photo' : 'empty');
      updateGenerate();
    }
  };
  generate.addEventListener('click', run);

  // Before / after
  const setView = (view) => {
    qa('[data-o-room-view]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.oRoomView === view)));
    beforeImg.hidden = view !== 'before';
  };
  qa('[data-o-room-view]').forEach((b) => b.addEventListener('click', () => setView(b.dataset.oRoomView)));

  again.addEventListener('click', () => { showSetup(); note.focus(); });
  next.addEventListener('click', () => {
    const primary = document.querySelector('[data-o-primary-action]');
    close();
    if (primary) { primary.scrollIntoView({ block: 'center' }); primary.click(); }
  });
  toast?.querySelector('[data-o-room-toast-open]')?.addEventListener('click', () => open());
  window.addEventListener('pagehide', () => { if (photoUrl) URL.revokeObjectURL(photoUrl); });
})();
